<!-- Generic Currency Field -->
<template>
  <div>

    <v-row style="align-items: center;">
      <v-col cols="12" md="12" sm="12"> 
        <div class="input-helper">
          <div class="element">   
            <v-text-field
              v-model="cmpValue"
              :label="cmpLabel"
              :tabindex="$attrs.tabindex"
              :placeholder="$attrs.placeholder"
              :readonly="$attrs.readonly"
              :disabled="$attrs.disabled"
              :outlined="$attrs.outlined"
              :dense="$attrs.dense"
              :error="$attrs.error"
              :rules="rules"
              :backgroundColor="$attrs.backgroundColor"
              :prefix="options.prefix"
              :suffix="options.suffix"
              v-on:keyup.enter="$attrs.keyup_enter"
              @paste="_paste"
              @keypress="_keyPress">

              <template slot="append" v-if="!$attrs.disabled">
                <v-btn x-small fab class="cleanBtn" 
                  elevation="0"
                  tabindex="-1"
                  v-if="cmpValue != undefined && cmpValue != null && cmpValue != ''" 
                  @click="cmpValue = undefined">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <template slot="append" v-if="$attrs.disabled">
                <v-icon tabindex="-1" color="stepper">mdi-check-circle</v-icon>
              </template>
            </v-text-field>
          </div>
          
          <div class="flex-btn"> 
            <v-btn x-small fab class="helperBtn" v-if="!!helperText"
              elevation="0"
              tabindex="-1"
              @click="_showHelperText">
              <v-icon>mdi-help</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    
    <HelperDialog
      :title="$attrs.label"
      :helperText="helperText"
      :show="helperTextPopUpVisible"
      @close="_closeHelperText">
    </HelperDialog>

  </div>

</template>

<script>

  import HelperDialog from "./helper-dialog.vue"
  import generic from '@/shared/utils/generic.js';

  export default {
    name: 'CurrencyField',
    inheritAttrs: false,
    components: {
      HelperDialog
    },
    props: {
      label: { type: String },
      rules: { type: Array },
      symbol: { type: String },
      value: { type: [String, Number] },
      valueWhenIsEmpty: { type: String }, // "0" or "" or null
      options: { type: Object, default: function () { return { locale: "", prefix: "", suffix: "", precision: 0, length: 11}; } },
      helperText: { type: String},
    },
    emits: ["input"],
    data: () => ({
      helperTextPopUpVisible: false,
      isRequired: undefined,
    }),
    created() {
      this.isRequired = generic.isRequired(this.rules);
    },
    methods: {
      _showHelperText () { 
        this.helperTextPopUpVisible = !!this.helperText;
      },

      _closeHelperText() { 
        this.helperTextPopUpVisible = false;  
      },

      uiFormat: function (number) {
        const opts = { maximumFractionDigits: this.options.precision, minimumFractionDigits: this.options.precision }
        return !number.isNumeric() ? "" : Number(number).toLocaleString(this.options.locale, opts);
      },

      machineFormat(number) {
        if (number) {
          number = generic.cleanNumber(number);
          number = number.padStart(parseInt(this.options.precision) + 1, "0"); // Pad Left
          // Decimal point for the floating defined
          number = number.substring(0, number.length - parseInt(this.options.precision)) + "." + number.substring(number.length - parseInt(this.options.precision), number.length);
          
          if (!number.isNumeric()) number = this.valueWhenIsEmpty;
        } 
        else number = this.valueWhenIsEmpty;
        
        if (this.options.precision === 0) number = generic.cleanNumber(number);
        return number;
      },
      
      _paste($event) {
        const pastedValue = $event.clipboardData.getData('text');
        if (pastedValue && (!pastedValue.isNumeric() || this.numberOutsideBoundaries(pastedValue))) $event.preventDefault();
      },
      _keyPress($event) {
        // Only allow numbers
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if (keyCode < 48 || keyCode > 57) $event.preventDefault();
        if (this.targetLength()) $event.preventDefault();
      },

      targetLength() {
        return Number(generic.cleanNumber(this.value).length) >= Number(this.options.length);
      },

      numberOutsideBoundaries(addedValue) {
        const numericValue = parseFloat(generic.cleanNumber(this.cmpValue ? this.cmpValue : 0) + generic.cleanNumber(addedValue));
        if (this.$attrs.max) return (numericValue > this.$attrs.max);
        if (this.$attrs.min) return (numericValue < this.$attrs.min);
        if (generic.cleanNumber(numericValue).length > Number(this.options.length)) return true;
        return false;
      }

    },

    computed: {
      cmpValue: { /* v-model="cmpValue": Typing will emit the input to the parent component */
        get: function () {
          const ret = this.value !== null && this.value !== undefined && this.value !== "" ? this.uiFormat(this.value.toString()) : this.valueWhenIsEmpty;
          return ret;
        },
        set: function (newValue) {
          this.showClearButton = newValue != undefined && newValue != null && newValue != '';
          this.$emit("input", this.machineFormat(newValue));
        },
      },
      cmpLabel: {
        get() { return this.label + (this.isRequired ? ' *' : '') },
      }
    },
  };
</script>

<style scoped>

</style>